import { PageHeader } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItemDinamico, RangePickerItem } from "../../../../Components/Items";
import round4Decimals from "../../../../Components/round4Decimals";
import DesgloseOrdenesPendientesInsumo from "./Components/DesgloseOrdenesPendientesInsumo";

class InsumosPendientesOrdenDeCompra extends Component {
  tableRef = null;
  state = {
    loading: false,
    todosInsumosPendientes: [],
    totalRecords: 0,
    periodo: undefined,
  };

  atras() {
    this.props.history.goBack();
  }

  onCambiarPeriodo(periodo) {
    this.setState({ periodo });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({
        periodo: periodo && periodo.length === 2 ? periodo : undefined,
      });
    }
  }

  async consultarInsumosPendientes(params = {}) {
    this.setState({ loading: true });

    await axios
      .post(
        "ordenesdecompra/selectInsumosPendientesOrdenDeCompra",
        { empresaId: this.props.empresaId, periodo: params.periodo },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todosInsumosPendientes: res.data.insumosPendientes || [],
            totalRecords: (res.data.insumosPendientes || []).length,
          });
        } else {
          this.setState({ todosInsumosPendientes: [], totalRecords: 0 });
        }
      })
      .catch((error) => {
        console.error("Error al consultar insumos pendientes de OC:", error);
        this.setState({ todosInsumosPendientes: [], totalRecords: 0 });
      });

    this.setState({ loading: false });
  }

  render() {
    const columns = [
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        width: "10%",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        width: "35%",
      },
      {
        title: "Unidad",
        dataIndex: "unidadNombre",
        key: "unidadNombre",
        width: "10%",
      },
      {
        title: "Pendiente por Recibir",
        dataIndex: "totalPendienteRecibir",
        key: "totalPendienteRecibir",
        width: "15%",
        sorter: (a, b) => a.totalPendienteRecibir - b.totalPendienteRecibir,
        render: (value) => round4Decimals(value).toFixed(4),
      },
      {
        title: "Pendiente por Facturar",
        dataIndex: "totalPendienteFacturar",
        key: "totalPendienteFacturar",
        width: "15%",
        sorter: (a, b) => a.totalPendienteFacturar - b.totalPendienteFacturar,
        render: (value) => round4Decimals(value).toFixed(4),
      },
      {
        title: "# Órdenes",
        dataIndex: "cantidadOrdenes",
        key: "cantidadOrdenes",
        width: "15%",
        sorter: (a, b) => a.cantidadOrdenes - b.cantidadOrdenes,
      },
    ];

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Insumos Pendientes de Recibir / Facturar"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <RangePickerItem
              allowClear
              value={this.state.periodo}
              onChange={this.onCambiarPeriodo.bind(this)}
              placeholder={["Fecha inicio", "Fecha fin"]}
            />
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onFetchData={this.consultarInsumosPendientes.bind(this)}
          totalRecords={this.state.totalRecords}
          dataSource={this.state.todosInsumosPendientes}
          loading={this.state.loading}
          columns={columns}
          size="small"
          pagination={false}
          rowKey={(record) => record.insumoId}
          expandable={{
            rowExpandable: () => true,
            expandedRowRender: (record) => (
              <DesgloseOrdenesPendientesInsumo
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                insumoId={record.insumoId}
                periodo={this.state.periodo}
                history={this.props.history}
              />
            ),
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(InsumosPendientesOrdenDeCompra);
